export enum GroupShareDialogModeEnum {
    CreateGroupShare = 1,
    EditGroupShare = 2
}